import { render, staticRenderFns } from "./vip-price.vue?vue&type=template&id=705a9e4f&scoped=true&"
import script from "./vip-price.js?vue&type=script&lang=js&"
export * from "./vip-price.js?vue&type=script&lang=js&"
import style0 from "./vip-price.vue?vue&type=style&index=0&id=705a9e4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705a9e4f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('705a9e4f')) {
      api.createRecord('705a9e4f', component.options)
    } else {
      api.reload('705a9e4f', component.options)
    }
    module.hot.accept("./vip-price.vue?vue&type=template&id=705a9e4f&scoped=true&", function () {
      api.rerender('705a9e4f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cart/components/vip-price/vip-price.vue"
export default component.exports